export const payTypeMap = {
  1: '线下结算',
  2: '线上结算'
}
export const payTypeMapCrud = {
  1: '线下支付',
  2: '线上支付'
  /* 原支付类型 */
  //0:'线下支付',
  //1:'线上支付'
}

export const payTypeCode = {
  '线下支付': 1,
  '线上支付': 2
}
